// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import userActions from '../../../actions/userActions';
import { initializedSelector, isLoggedInSelector } from '../../../selectors/userSelectors';
import App from '../App';
import type { Props } from '../App';

const mapStateToProps = (state: State) => {
    return {
        userInitialized: initializedSelector(state),
        isLoggedIn: isLoggedInSelector(state)
    };
};

const mapDispatchToProps = {
    setUser: userActions.setUser
};

export default connect<Props, *, _, _, _, _>(mapStateToProps, mapDispatchToProps)(App);